import { h } from 'preact';


interface Props {
  // Percent of the vote, 0-100
  value: number;
  party?: string;
  // Custom candidate color, used in place of the party color when set
  color?: string;
}

// Spelled out in full so PurgeCSS (config/tasks/unused-css.js) keeps them.
// Same party colors as the PartyPill circles.
const PARTY_CLASSES: { [prefix: string]: string } = {
  rep: 'vote-bar__fill--rep',
  dem: 'vote-bar__fill--dem',
  lib: 'vote-bar__fill--lib',
  ind: 'vote-bar__fill--ind',
  gre: 'vote-bar__fill--gre',
};

// Thin bar under a candidate's name showing their share of the vote
function VoteBar({ value, party, color }: Props) {
  const partyClass = party && PARTY_CLASSES[party.slice(0, 3).toLowerCase()];
  const width = Math.max(0, Math.min(100, value || 0));

  const style: { [key: string]: string } = { width: `${width}%` };
  if (color) style['background-color'] = color;

  return (
    <span class="vote-bar" aria-hidden="true">
      <span
        class={partyClass ? `vote-bar__fill ${partyClass}` : 'vote-bar__fill'}
        style={style}
      />
    </span>
  );
}

export default VoteBar;
